import { api } from "..";
import { NewUser } from "@/types/ApiResponses/User";

interface UpdateUserPayload {
  image?: string;
}

export const updateUser = async (
  payload: UpdateUserPayload
): Promise<NewUser> => {
  const res = await api.client.patch("/account", payload);
  return res.data;
};
